import React from 'react'
import { Link } from 'react-router-dom'
import { Button, logOut } from '../components/Button'
import styles from './User.module.css'
import logo from '../images/logo.svg'
  
export const User = ({ user }) => {
     
    return (
        <>
            <img className={styles.logo} src={logo} alt="Logo"/>
            <div className={styles.links}>
                {!user ? (
                    <>
                        <Link to="/sign-in"><Button>Anmelden</Button></Link>
                        <Link to="/sign-up"><Button>Registrieren</Button></Link>
                    </>
                ) : (
                    <>
                        <Link to="/edit-profile"><Button>Profil bearbeiten</Button></Link>
                        <Button onClick={logOut}>Abmelden</Button>
                    </>
                )
                }
            </div >
        </>
    )
}